import * as path from "path"
import * as os from "os"

/**
 * YAM engine will detect these files in working directory.
 */
export const APP_MODEL_FILES = ['app.yaml', 'app.yml', 'yam.yaml', 'yam.yml']

/**
 * YAM engine will detect values/ directory to fetch env related dynamic parameters recursively in working directory
 */
export const VALUES_DIR = "values"

/**
 * Built-int default YAM schema name. 'schema: application/1.x'
 */
export const SCHEMA_NAME = 'application'

/**
 * YAM engine will backup the application model declaration to ConfigMap,
 * for implementing Previous-Current Diff and Canary release rotation.
 */
export const YAM_PREFIX = 'yam-'

export const STACK_ENV_DELIMITER = '/'

export const LOCK_PREFIX = 'yam-lock-'
export const LOCK_MSG = 'already locked.'

export const DEFAULT_KUBE_CONFIG = (): string => {
  return process.env.KUBECONFIG || path.join(os.homedir(), ".kube", 'config')
}

/**
 * Built-in parameters could be directly referenced by placeholder, eg: ~{ version } or ~{ engTag }
 */
export const BUILT_IN_PARAM_MAP = {
  VERSION: "version",
  ENVIRONMENT: "env",
  STACK: "stack",
  WORKLOAD: "workload",

  // Default levels when env hierarchy not specified
  REGION: 'region',
  ZONE: 'zone'
}

export const BUILT_IN_PARAMS = Object.values(BUILT_IN_PARAM_MAP)

export const JSON_PATH_PREFIX = "$."

export const MAX_LINES_OF_LOGS = 256
export const MAX_BYTES_PER_LINE = 500

export const K8S_REQUEST_TIMEOUT = 12000

export const MAX_FORWARD_CHECK_TIMES = 10

export const MAX_JOB_STATUS_CHECK_TIME = 60 * 60 * 1000
export const DEFAULT_STATUS_CHECK_TIME = 5 * 60 * 1000
export const STATUS_CHECK_INTERVAL = 5000

export const EXEC_DEFAULT_CMD = ["sh", "-c", "clear; (bash || ash || sh)"]

// Default environment key
export const DEFAULT_ENV_KEY = '_'
